import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogTitle } from "../components/DialogTitle";
import { DialogContent } from "../components/DialogContent";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { NewTextInput } from "../components/NewTextInput";

const styles = theme => ({
  root: {
    bottom: theme.spacing(1)
  },
  divider: {
    color: theme.palette.primary.main
  },
  content: {
    // minHeight: "100px",
    // textAlign: "center",
    // margin: "50px"
  },
  buttonsContainer: {
    textAlign: "Right"
  },
  button: {
    textTransform: "none",
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1)
  }
});

export const AreYouSureDialogWithTextRequirement = withStyles(styles)(
  ({ title, body, onClose, classes, onDelete, textRequirement, children }) => {
    let [validText, setValidText] = useState(false);
    return (
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        scroll="body"
        open
        spacing={0}
        className={classes.root}
        onClose={onClose}
      >
        <DialogTitle onCancel={onClose}>
          <b>{title}</b>
        </DialogTitle>
        <DialogContent>
          <div className={classes.content}>
            <Typography variant="body">{body}</Typography>
            {children}
            <Typography variant="caption">You must enter the text "{textRequirement}" into the field before you can complete the operation.</Typography>
            <NewTextInput
              label={textRequirement}
              value={""}
              onChange={(value) => setValidText(value === textRequirement)}
            />
          </div>
          <div className={classes.buttonsContainer}>
            <Button
              aria-label="Edit"
              color="secondary"
              variant="contained"
              className={classes.button}
              onClick={onDelete}
              disabled={!validText}
            >
              Delete
          </Button>
            <Button
              aria-label="Edit"
              color="primary"
              variant="contained"
              className={classes.button}
              onClick={onClose}
            >
              Cancel
          </Button>
          </div>
        </DialogContent>
      </Dialog>
    )
  });
